import clienteAxios from "../config/axios";

export async function getAbmDistribucion() {
    return clienteAxios.get(`/abmDistribution`);
}

export async function uploadAbmDistribucion() {
    return clienteAxios.post('/abmDistribution/actualizar');
}

export async function getAbmSubcuentaDistribucion() {
    return clienteAxios.get(`/abmSubcuentaDistribution`);
}

export async function getAbmSubcuentasDistribucionByCodDimAndCodDis(codDim, codDis) {
    return clienteAxios.get(`/abmSubcuentaDistributionByCodDimAndCodDis/${codDim}/${codDis}`);
}